import type { ListBuilderMobileCardConfig } from '../../types';

/**
 * Required fields for shop_default list (all columns including sales/invoice data)
 */
export const SHOP_DEFAULT_REQUIRED_FIELDS = [
	'_id',
	'primaryImageUrl',
	'category',
	'description',
	'externalId',
	'externalId2',
	'isShortDate',
	'isHazmat',
	'isRefrigerated',
	'manufacturer',
	'minimumPrice',
	'price',
	'quantityOnHand',
	'quantityReserved',
	'quantityOnOrder',
	'sizeCount',
	'soonestExpirationDate',
	'subcategory',
	'unitOfMeasure',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
];

/**
 * Required fields for shop_suggested (reorder) list - includes forecast fields
 */
export const SHOP_SUGGESTED_REQUIRED_FIELDS = [
	'client_shop._id',
	'client_shop.primaryImageUrl',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
	'addressForecastedReorderDate',
	'addressForecast',
	'item._id',
	'item.category',
	'item.description',
	'item.externalId',
	'item.isShortDate',
	'item.isHazmat',
	'item.isRefrigerated',
	'item.manufacturer',
	'item.minimumPrice',
	'item.price',
	'item.quantityOnHand',
	'item.quantityReserved',
	'item.quantityOnOrder',
	'item.sizeCount',
	'item.soonestExpirationDate',
	'item.subcategory',
	'item.unitOfMeasure',
];

/**
 * Required fields for at_risk, previously_purchased, short_date lists
 */
export const SHOP_STANDARD_REQUIRED_FIELDS = [
	'client_shop._id',
	'client_shop.primaryImageUrl',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
	'item._id',
	'item.category',
	'item.description',
	'item.externalId',
	'item.isShortDate',
	'item.isHazmat',
	'item.isRefrigerated',
	'item.manufacturer',
	'item.minimumPrice',
	'item.price',
	'item.quantityOnHand',
	'item.quantityReserved',
	'item.quantityOnOrder',
	'item.sizeCount',
	'item.soonestExpirationDate',
	'item.subcategory',
	'item.unitOfMeasure',
];

/**
 * Required fields for the Recently Restocked tab — standard set plus
 * lastRestockedDate (the column displayed in this tab).
 */
export const SHOP_RECENTLY_RESTOCKED_REQUIRED_FIELDS = [
	...SHOP_STANDARD_REQUIRED_FIELDS,
	'item.lastRestockedDate',
];

/**
 * Required fields for the Newly Stocked tab — standard set plus the two
 * fields the computed created-date column derives from.
 */
export const SHOP_NEWLY_STOCKED_REQUIRED_FIELDS = [
	...SHOP_STANDARD_REQUIRED_FIELDS,
	'item.externalCreatedDate',
	'item._created_date',
];

/**
 * Required fields for purchased_together list (minimal fields)
 */
export const SHOP_PURCHASED_TOGETHER_REQUIRED_FIELDS = [
	'client_shop._id',
	'client_shop.primaryImageUrl',
	'item._id',
	'item.category',
	'item.description',
	'item.externalId',
	'item.isShortDate',
	'item.isHazmat',
	'item.isRefrigerated',
	'item.manufacturer',
	'item.minimumPrice',
	'item.price',
	'item.quantityOnHand',
	'item.quantityReserved',
	'item.quantityOnOrder',
	'item.sizeCount',
	'item.soonestExpirationDate',
	'item.subcategory',
	'item.unitOfMeasure',
];

/**
 * Standard mobile card config for shop lists
 */
export const SHOP_MOBILE_CARD_CONFIG: ListBuilderMobileCardConfig = {
	primaryFields: ['item_details'],
	secondaryFields: ['category', 'stock'],
	controlsColumns: ['actions'],
	hiddenFields: ['image'],
};
